export default __webpack_public_path__ + "static/media/rudes_crypto_launge.cb61bca2.jpeg";